import { IconName } from '@billy/design-system'

interface InfoCard {
  icon: IconName
  titleKey: string
  descriptionKey: string
}

export const getInfoCards = (isFreePlan: boolean): InfoCard[] => [
  {
    icon: 'hourglass',
    titleKey: 'settings.organization.card_payments.cards.speed.title',
    descriptionKey: 'settings.organization.card_payments.cards.speed.description',
  },
  {
    icon: 'creditCard',
    titleKey: 'settings.organization.card_payments.cards.fees.title',
    descriptionKey: isFreePlan
      ? 'settings.organization.card_payments.cards.fees.description.free_plan'
      : 'settings.organization.card_payments.cards.fees.description',
  },
  {
    icon: 'lockKeyhole',
    titleKey: 'settings.organization.card_payments.cards.trust.title',
    descriptionKey: 'settings.organization.card_payments.cards.trust.description',
  },
]
